<template>
    <div id="app" class="index-wrap" :class="'index-'+vipDay+'-wrap'">
        <section class="address-wrap" ref="address">
            <p>
                <span class="address-icon"></span>
                <span style="display: none">最快</span>
                <span style="display: none" class="address-date">{{deliverTime}}</span>
                <span class="address-date-line">送至</span>
                <a href="/pages/address_list/address_list.html" class="address-info" data-ca="跳转到地址列表">{{addressInfo}}</a>
                <i>❯ </i>
            </p>
        </section>
        <section class="nav-wrap" ref="nav">
            <div class="scroll-wrap" ref="scrollNavWrap">
                <ul ref="scrollUl" class="scroll-ul">
                    <li v-for="(item,index) in navList" @click.stop="navScroll(index)" class="analysis" :class="{checked : nowIndex == index}" :data-id="item.indexNavId"  :data-analysis="'导航切换到'+item.navName">{{item.navName}}</li>
                </ul>
            </div>
            <p class="nav-button" :class="toggleNavBtn?'nav-button-on':''" @click="toggleNav"><i class="icon iconfont icon-jiantouyou"></i> </p>
        </section>
        <swiperAdvEnter :platformName="platformName" :vipLevel="vipLevel"></swiperAdvEnter>
        <!--<template v-if="vipDay == 'isvipday'" >-->
            <!--<vipDay :endTimeV="endTime" :vipLevel="vipLevel"></vipDay>-->
        <!--</template>-->
        <template v-if="vipTask !=null" :vipTask="vipTask">
            <vipTask :vipTask="vipTask"></vipTask>
        </template>

        <sectionPro :sectionList="sectionList" :proShowModel="proShowModel" :vipLevel="vipLevel" :vipDay="vipDay"></sectionPro>
        <footerCart :footerSelect="footerSelect"></footerCart>
        <indexBanner></indexBanner>

    </div>
</template>

<script>
    import {GetQueryString} from '@/resource/js/common'
    import {invokeApi} from '@/resource/js/GLOBAL2'
    import prompt from '@/components/prompt/prompt'
    import footerCart from '@/components/footer/footerHtml'
    import sectionPro from '@/components/index/section_pro'
    import vipDay from './component/vip_day.vue'
    import vipTask from './component/vip_task.vue'
    import swiperAdvEnter from '@/components/index/swiper_adv_enter'
    import indexBanner from '@/components/indexBanner/indexBanner'

    export default{
        data(){
            return {
                domainName:true,
                footerSelect:'index',
                proShowModel:0,
                nowIndex:0,
                vipLevel:0,
                vipInfo:[],
                vipTask:null,
                vipDay:'notvipday',//0平日,1会员日
                platformName:'lechun',
                isNew:0,
                toggleNavBtn:false,
                scrollUlWidth:0,
                isNavClick:0
            }
        },
        components:{
            footerCart,sectionPro,swiperAdvEnter,vipDay,vipTask,indexBanner
        },
        computed:{
            addressInfo(){
                return this.$store.state.cartNew.addressInfo
            },
            deliverTime(){
                return this.$store.state.cartNew.deliverTime
            },
            navList:function(val){
                let listSet = this.$store.getters.indexSectionListSet
                let list = this.$store.state.cartNew.indexSectionList
                return listSet.length>0?listSet:list
            },
            sectionList:function(val){
                let listSet = this.$store.getters.indexSectionListSet
                let list = this.$store.state.cartNew.indexSectionList
                return listSet.length>0?listSet:list
            },
        },
        mounted(){
            this.initIndexInfo();
            this.getIndexSectionPro();
            window.addEventListener('scroll', this.scrollNav);
            this.$refs.scrollNavWrap.addEventListener('scroll',(e)=>{
                this.getNavWidth()
            })
            localStorage.setItem('urlItem', window.location.pathname + window.location.search+window.location.hash);

        },
        methods:{
            initIndexInfo(){
                let _this= this;
                invokeApi('/index/getFirstPageCount',{},'get',Math.random(),function (res) {
                    _this.vipLevel = res.vipInfo.level?res.vipInfo.level:0;
                    _this.vipInfo = res.vipInfo;
                    _this.vipDay = res.vipInfo.isVipDay;
                    _this.vipTask = res.vipInfo.vipTask;
                    _this.endTime = res.vipInfo.vipDay?res.vipInfo.vipDay.endTime:0;
                    _this.isNew = res.isNew;

                })

            },
            getIndexSectionPro(){
                this.$store.dispatch('initIndexDataInfo',{itemType:0})
            },
            navScroll(index) {
                var targetItem = 'section' + index;
                this.nowIndex = index;
                var scroll = document.getElementsByClassName(targetItem)[0].offsetTop - this.$refs.address.offsetHeight - this.$refs.nav.offsetHeight;
                this.isNavClick = 1;
                window.scrollTo(0, scroll);
                this.toggleNavBtn = false
            },
            scrollNav() {
                var scrollT = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                var initHeight = this.$refs.address.offsetHeight + this.$refs.nav.offsetHeight + 3 * window.screen.height / 5;
                this.toggleNavBtn = false
                this.getNavWidth()
                if (this.isNavClick != 1) {
                    var sectionArr = document.getElementsByClassName('section-item');
                    for (var i = 0; i < sectionArr.length; i++) {
                        var sectionPre = sectionArr[i - 1];
                        var section = sectionArr[i];
                        if (i < 1) {
                            if (scrollT <= (section.offsetTop + section.offsetHeight - initHeight)) {
                                this.nowIndex = i;
                            }
                        } else {
                            if (scrollT <= (section.offsetTop + section.offsetHeight - initHeight) && scrollT > (sectionPre.offsetTop + sectionPre.offsetHeight - initHeight)) {
                                this.nowIndex = i;
                            }
                        }
                    }
                }
                this.scrollUlNavLeft(this.nowIndex)
                this.isNavClick = 0;
            },
            toggleNav(){
                this.toggleNavBtn = !this.toggleNavBtn
                this.getNavWidth()
                this.scrollUlNavLeft(this.nowIndex)

            },
            scrollUlNavLeft(index){
                let ulItem = document.querySelectorAll('.scroll-ul')[0];
                let liItem = ulItem.childNodes;
                let scrollW = this.$refs.scrollNavWrap.clientWidth+this.$refs.scrollNavWrap.offsetLeft
                let liItemW = liItem[index].offsetLeft+liItem[index].clientWidth
                let setV = Math.ceil(liItemW*2/scrollW)
                this.$refs.scrollNavWrap.scrollLeft=setV*scrollW/2-scrollW>0?setV*scrollW/2-scrollW:0
            },
            getNavWidth(){
                let ulItem = document.querySelectorAll('.scroll-ul')[0];
                let liItem = ulItem.childNodes;
                this.scrollUlWidth = 0
                for(let i=0;i<liItem.length;i++){
                    this.scrollUlWidth+=Math.ceil(liItem[i].clientWidth)+1
                }
                if(this.toggleNavBtn){
                    ulItem.style.width = 'auto'
                }else{
                    ulItem.style.width = this.scrollUlWidth<=0?'1000%':this.scrollUlWidth+'px'
                }
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    $rem:0.01rem;
    html{
        background: #f7f7f7;
    }
    .index-isvipday-wrap{
        /*background: -webkit-linear-gradient(left, #ed1525, #ff3c61 49%, #ff594c 95%);*/
    }

    .index-wrap {
        margin-bottom: 1.3rem;
        /**address**/
        .address-wrap {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 4;
            width: 100%;
            /*height: .58rem;*/
            text-align: center;
            background: #ffffff;
            box-sizing: border-box;
            padding: .34rem .24rem .06rem;
        }

        .address-wrap p {
            color: #222222;
            display: -webkit-box;
            -webkit-box-pack: center;
            -webkit-box-align: center;
            font-size: .22rem;
            border-radius: .3rem;
        }
        .address-wrap .address-icon{
            width: .22rem;
            height: .26rem;
            display: block;
            background: url('./images/address-icon.png') top left no-repeat;
            background-size: .22rem auto;
            margin-right: .12rem;
        }

        .address-wrap span, .address-wrap i, .address-wrap a {
            display: block;
            font-style: normal;
        }
        .address-date{
            color: #e50011;
            margin: 0 .12rem;

        }
        .address-info {
            color: #222222;
            margin: 0 .09rem;
        }

        .address-info {
            max-width: 1.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .address-date-line{
            color: #999999;
        }

        /**nav**/
        .nav-wrap {
            position: fixed;
            top: .63rem;
            left: 0;
            z-index: 3;
            width: 100%;
            padding: .02rem .7rem 0 .24rem;
            background: #ffffff;
            box-sizing: border-box;
            box-shadow: 0 .04rem .3rem rgba(0, 0, 0, .2);
            .scroll-wrap{
                overflow-x: scroll;
                width: 100%;
            }
            ul {
                display: flex;
                flex-wrap: wrap;
                width: 1000%;
                padding: .34rem 0 0;
                li {
                    position: relative;
                    text-align: center;
                    font-size: .28rem;
                    color: #333333;
                    padding-right: .24rem;
                    padding-bottom: .34rem;
                }
                li.checked {
                    color: #e50011;
                    font-weight: bolder;
                }

            }
            .nav-button{
                position: absolute;
                right: 0;
                top:0.3rem;
                width:70*$rem;
                background: #ffffff;
                box-sizing: border-box;
                padding-left: .15rem;
                i{
                    display: inline-block;
                    transform: rotate(90deg);
                    transform-origin: 50% 50%;
                    transition: all .5s ease 0s;
                }
            }
            .nav-button-on{
                i{
                    transform: rotate(-90deg);
                    transform-origin: 50% 50%;
                    transition: all .5s ease 0s;
                }
            }
        }
    }

    .index-wrap > section {
        width: 100%;
    }
    .new-bottom-tips{
        position: fixed;
        left: 50%;
        bottom: 1.6rem;
        z-index: 2;
        -webkit-transform: translateX(-50%);
        em{
            font-size: .22rem;
            background: rgba(0, 0, 0, .5);
            line-height: .6rem;
            padding: 0 .28rem;
            color: #ffffff;
            white-space: nowrap;
            border-radius: .34rem;
            display: block;
        }
    }



</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue